import React, { useContext, useCallback } from 'react';
import {
  RangeGroupSection,
  ProductCollectionFilter,
} from '../../../../../types';
import RadioButtons from './components/radio-buttons';
import RouteContext from '../../../../../routes/context';

import * as ListStyles from './list/styles';
import * as SectionStyles from './styles';

type Props = Pick<RangeGroupSection, 'groups' | 'title' | 'property'> & {
  showTitle?: boolean;
};

const RangeGroup = ({ groups, title, property, showTitle }: Props) => {
  const { dispatch, getState } = useContext(RouteContext);
  const { filters } = getState();

  const onClickItem = useCallback(
    id => {
      dispatch({
        type: 'FILTER_RANGE_GROUP_UPDATE',
        property,
        id,
      });
    },
    [dispatch, property]
  );

  const selectedFilter = filters.find(
    (filter: ProductCollectionFilter) => filter.property === property
  );

  const getSelectedState = useCallback(
    id => {
      if (!selectedFilter) {
        return false;
      }

      return selectedFilter.key === id;
    },
    [selectedFilter]
  );

  return (
    <SectionStyles.Section>
      {showTitle && (
        <SectionStyles.SectionTitle>{title}</SectionStyles.SectionTitle>
      )}
      <ListStyles.OptionList>
        <RadioButtons
          items={groups}
          getSelectedState={getSelectedState}
          onClickItem={onClickItem}
        />
      </ListStyles.OptionList>
    </SectionStyles.Section>
  );
};

export default RangeGroup;
